import { render } from "./form-reset-password.vue?vue&type=template&id=3433b2ca"
import script from "./form-reset-password.vue?vue&type=script&lang=js"
export * from "./form-reset-password.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__